<template>
    <div v-if="show">
        <el-dialog :visible.sync="show" :title="name" width="900px">
            <div class="cf" style="padding: 10px">
                <div class="fl">
                    <el-input v-model="search.keyWord" placeholder="输入名称或编码" size="mini"
                              style="width: 150px; margin-right: 10px" @change="searchInit()" clearable></el-input>
                </div>
                <div class="fr">
                    <el-tooltip class="item" effect="dark" content="刷新" placement="top">
                        <el-button size="mini" @click="init()" circle icon="el-icon-refresh">
                        </el-button>
                    </el-tooltip>
                    <el-button type="primary" size="mini" @click="create()">
                        创建字段
                    </el-button>
                </div>
            </div>
            <el-table :data="data" border size="mini" style="width: 100%" height="400" v-loading="loading">
                <template slot="empty">
                    <el-empty></el-empty>
                </template>
                <el-table-column prop="name" label="字段名称" min-width="180" show-overflow-tooltip
                                 align="center"></el-table-column>
                <el-table-column prop="code" label="字段编码" min-width="180" show-overflow-tooltip
                                 align="center"></el-table-column>
                <el-table-column prop="aliasCode" label="字段编辑编码" min-width="180" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" label="类型" width="100" show-overflow-tooltip align="center"
                                 :formatter="formatterType"></el-table-column>
                <el-table-column prop="sort" label="排序" width="100" align="center"></el-table-column>
                <el-table-column fixed="right" width="60" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="edit(scope.row)">修改</el-button>
                        <!--            <el-button type="text" size="mini" @click="del(row)" :disabled="!row.isExt">删除</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: left; padding: 10px 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="page.current" :page-sizes="[20, 50, 80, 100]" :page-size="page.size"
                               layout="total, sizes, prev, pager, next, jumper" :total="page.total" background>
                </el-pagination>
            </div>
        </el-dialog>
        <field-detail ref="fieldDetail" @init="init"/>
    </div>
</template>

<script>
import fieldDetail from './fieldDetail.vue'

export default {
    data() {
        return {
            show: false,
            name: '',
            row: {},
            data: [],
            allAlign: 'center',
            loading: false,
            page: {
                size: 20,
                current: 1,
                total: 0
            },
            search: {},
            dataList: [
                {value: 'text', label: '文本'},
                {value: 'number', label: '数字'},
                {value: 'select', label: '单选'},
                {value: 'date', label: '日期'},
                {value: 'dateTime', label: '日期时间'},
                {value: 'boolean', label: '布尔'},
                {value: 'many2one', label: '多对一'},
                {value: 'fileUpload', label: '文件上传'},
                {value: 'imgUpload', label: '图片上传'},
                {value: 'sqlFormula', label: '后台公式'}
            ]
        }
    },
    components: {fieldDetail},
    methods: {
        display(data) {
            this.row = data.row
            this.name = data.name
            this.show = true
            this.init()
        },

        init() {
            this.loading = true
            const params = {
                params: {
                    pageNum: this.page.current,
                    pageSize: this.page.size
                }
            }
            for (let key in this.search) {
                if (this.search[key])
                    params.params[key] = this.search[key]
            }
            this.$axios.get(`/query/basicsFields/list/${this.row.code}`, params).then(res => {
                if (res) {
                    const data = res.data.data
                    this.data = data.list.sort(this.compare('sort'))
                    this.page.total = data.total
                    this.loading = false
                } else {
                    this.loading = false
                }
            })
                .catch(() => {
                    this.loading = false
                })
        },
        compare(property) {
            return function (a, b) {
                let value1 = a[property];
                let value2 = b[property];
                return value1 - value2;
            }
        },

        searchInit() {
            this.page.current = 1
            this.init()
        },
        handleSizeChange(val) {
            this.page.size = val
            this.init()
        },
        handleCurrentChange(val) {
            this.page.current = val
            this.init()
        },

        create() {
            const data = {
                data: {
                    modelId: this.row.id,
                    isExt: false,
                    modelCode: this.row.code,
                    mobileType: 'all',
                    isOrderBy: false,
                    isGroupBy: false,
                    isSelect: true,
                    isSearch: true,
                    dicIds: []
                },
                name: '创建字段',
                row: this.row,
                isCreate: true
            }
            this.$refs.fieldDetail.display(data)
        },

        edit(row) {
            this.$axios.get(`/query/basicsFields/get/${row.id}`).then(res => {
                const data = {
                    data: res.data.data,
                    name: '修改字段',
                    row: this.row,
                    isCreate: false
                }
                this.$refs.fieldDetail.display(data)
            })
        },

        formatterType(row) {
            let value
            this.dataList.forEach(item => {
                if (item.value === row.type) {
                    value = item.label
                }
            })
            return value
        },

        del(row) {
            this.$confirm('确定删除该条单据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$axios.get(`/query/templateField/del/${row.id}`).then(res => {
                    if (res) {
                        this.init()
                        this.$message.success('操作成功')
                    }
                })
            }).catch(() => {
            })
        }

    }
}
</script>
<style scoped>
.cf {
    overflow: hidden
}

.fl {
    float: left;
}

.fr {
    float: right;
}
</style>
